<script setup lang="ts">
// The hero lockup mark for Direction A "The Almanac": a fanned euchre hand with
// Michigan dealt as the home card. Ported from logos.jsx.
import { computed } from 'vue'
import { BK } from './tokens'
import SuitCard from './marks/SuitCard.vue'
import MichiganCard from './marks/MichiganCard.vue'

const props = withDefaults(defineProps<{ scale?: number }>(), { scale: 1 })

const wrapStyle = computed(() => ({
  width: `${232 * props.scale}px`,
  height: `${168 * props.scale}px`,
}))
const spadeStyle = computed(() => ({
  bottom: `${8 * props.scale}px`,
  transform: 'translateX(-50%) rotate(-20deg)',
}))
const heartStyle = computed(() => ({
  bottom: `${8 * props.scale}px`,
  transform: 'translateX(-50%) rotate(20deg)',
}))
</script>

<template>
  <div class="almanac-mark" :style="wrapStyle">
    <div class="almanac-mark__fan" :style="spadeStyle">
      <SuitCard :w="72 * scale" suit="♠" :color="BK.pine" />
    </div>
    <div class="almanac-mark__fan" :style="heartStyle">
      <SuitCard :w="72 * scale" suit="♥" :color="BK.barn" />
    </div>
    <div class="almanac-mark__home">
      <MichiganCard :w="96 * scale" />
    </div>
  </div>
</template>

<style scoped>
.almanac-mark {
  position: relative;
}
.almanac-mark__fan {
  position: absolute;
  left: 50%;
  transform-origin: bottom center;
  z-index: 1;
}
.almanac-mark__home {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
}
</style>
